import {ForwardedRef, forwardRef, useMemo, useRef, useState} from "react";
import {PropsValue, SelectInstance} from "react-select";

import {LocationSelectLimitedProps} from "@/components/LocationSelect/LocationSelectLimited.types.ts";
import {limitChangesHandlerCurry} from "@/components/LocationSelect/LocationSelectLimited.utils.ts";
import {LocationSelect} from "@/components/LocationSelect/subComponents/BaseLocationSelect/LocationSelect.tsx";
import {MonitoringGroup} from "@/lib/types/monitoring.ts";
import {LimitCheckLocationsCountLimit} from "@/pages/billing/v2/InstantCheckout/LimitCheckLocationsCountLimit.tsx";
import {LimitCheckLocationTierLimit} from "@/pages/billing/v2/InstantCheckout/LimitCheckLocationTierLimit.tsx";
import {LimitCheckerComponent} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";

export const LocationSelectLimited = forwardRef(
  (
    {onChange, limitMonitoringGroupLevel, limitMonitoringGroups, ...props}: LocationSelectLimitedProps,
    ref: ForwardedRef<SelectInstance<MonitoringGroup, boolean>>
  ) => {
    const [value, setValue] = useState<PropsValue<MonitoringGroup>>(null);
    const locCntRef = useRef<LimitCheckerComponent>();
    const locTierRef = useRef<LimitCheckerComponent>();

    const onChangeHandler = useMemo(
      () =>
        limitChangesHandlerCurry(
          limitMonitoringGroupLevel,
          limitMonitoringGroups,
          locCntRef,
          locTierRef,
          setValue,
          onChange,
          props.isMulti
        ),
      [limitMonitoringGroupLevel, limitMonitoringGroups, setValue, onChange, props.isMulti, locCntRef, locTierRef]
    );

    return (
      <>
        <LimitCheckLocationsCountLimit ref={locCntRef} />
        <LimitCheckLocationTierLimit ref={locTierRef} />
        <LocationSelect
          ref={ref}
          onChange={onChangeHandler}
          value={value}
          limitMonitoringGroupLevel={limitMonitoringGroupLevel}
          {...props}
        />
      </>
    );
  }
);
